export default __webpack_public_path__ + "static/media/couleurs.1c84bad5.png";